// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusProject_wrapper__UvBBC","logo":"StatusProject_logo__qpazQ","absolute_logo":"StatusProject_absolute_logo__MH3fy"};